import axios from 'axios';

import ENDPOINT from '../../context/EndPoint';

const AdminDeleteQuiz = async ({payload}) => {

          const formData = new FormData();

           formData.append('session',payload.user);
           formData.append('quiz_id',payload.quiz_id);


           try{
               const res = await axios.post(ENDPOINT+"delete-quiz.php", formData,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                if(res.data){
                    return res.data
             
                }
           }
           catch(error){

return error
           }

     




}

export default AdminDeleteQuiz